import { Icon } from "./Icon.tsx";

/** "Edit" icon for a catalog row's own edit button (opens its edit dialog) — sized/styled to match TrashIcon via the shared Icon.tsx wrapper, unlike the standalone PencilIcon.tsx (top bar only). */
export function EditIcon() {
  return (
    <Icon>
      <path d="M4 20l1-4.5L16 4.5a1.5 1.5 0 0 1 2 0l1.5 1.5a1.5 1.5 0 0 1 0 2L8.5 19 4 20Z" />
      <path d="M14 6.5 17.5 10" />
    </Icon>
  );
}
